import { createContext } from 'react'

/** Opening a table in a chat is explicit; outside this provider cards remain ordinary links. */
export const TableNavigationContext = createContext<{ matterId: string; openTable: (tableId: string) => void } | null>(null)
